import _implicitStylesheets from "./mvpApproved.css";
import _implicitScopedStylesheets from "./mvpApproved.scoped.css?scoped=true";
import _axImage from "ax/image";
import _wdsLink from "wds/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<a class="axwp-mvp-approved__link${0}"${"a0:href"}${"a0:target"}${2}><p class="axwp-mvp-approved__image-title${0}"${2}>${"t2"}</p></a>`;
const $fragment2 = parseFragment`<p class="axwp-mvp-approved__image-title${0}"${2}>${"t1"}</p>`;
const $fragment3 = parseFragment`<p class="axwp-mvp-approved__image-caption${0}"${2}>${"t1"}</p>`;
const $fragment4 = parseFragment`<h3 class="axwp-mvp-approved__title${0}"${2}>${"t1"}</h3>`;
const $fragment5 = parseFragment`<h5 class="axwp-mvp-approved__subtitle${0}"${2}>${"t1"}</h5>`;
const stc0 = {
  classMap: {
    "axwp-mvp-approved": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "axwp-mvp-approved__image-wrapper": true
  },
  key: 1
};
const stc2 = {
  "axwp-mvp-approved__link": true
};
const stc3 = {
  classMap: {
    "axwp-mvp-approved__content": true
  },
  key: 13
};
const stc4 = {
  attrs: {
    "name": "content"
  },
  key: 18
};
const stc5 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, s: api_slot} = $api;
  return [api_element("div", stc0, [api_element("div", stc1, [$cmp.hasLink ? api_custom_element("wds-link", _wdsLink, {
    props: {
      "href": $cmp.mvpLink
    },
    key: 2
  }, [$cmp.hasImage ? api_element("a", {
    classMap: stc2,
    attrs: {
      "href": $cmp.mvpLink,
      "target": $cmp.mvpLinkTarget
    },
    key: 3
  }, [api_custom_element("ax-image", _axImage, {
    props: {
      "imgSrc": $cmp.image
    },
    key: 4
  })]) : null]) : null, !$cmp.hasLink ? api_custom_element("ax-image", _axImage, {
    props: {
      "imgSrc": $cmp.image
    },
    key: 5
  }) : null, $cmp.hasLink ? api_custom_element("wds-link", _wdsLink, {
    props: {
      "href": $cmp.mvpLink
    },
    key: 6
  }, [$cmp.hasImageTitle ? api_static_fragment($fragment1, 8, [api_static_part(0, {
    attrs: {
      "href": $cmp.mvpLink,
      "target": $cmp.mvpLinkTarget
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.imageTitle))]) : null]) : null, !$cmp.hasLink ? api_static_fragment($fragment2, 10, [api_static_part(1, null, api_dynamic_text($cmp.imageTitle))]) : null, $cmp.hasImageCaption ? api_static_fragment($fragment3, 12, [api_static_part(1, null, api_dynamic_text($cmp.imageCaption))]) : null]), api_element("div", stc3, [$cmp.hasMvpTitle ? api_static_fragment($fragment4, 15, [api_static_part(1, null, api_dynamic_text($cmp.mvpTitle))]) : null, $cmp.hasMvpSubtitle ? api_static_fragment($fragment5, 17, [api_static_part(1, null, api_dynamic_text($cmp.mvpSubtitle))]) : null, api_slot("content", stc4, stc5, $slotset)])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["content"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2h2dm8hnmsk";
tmpl.legacyStylesheetToken = "undefined-_mvpApproved";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
